import { mxConstants } from 'mxgraph-js';
import FaultTreeTransferGateVertex from '../FaultTreeTransferGateVertex';
import GateVertexValue from '../../GateNode/GateVertexValue';

class FaultTreeInstanceTransferGateVertex extends FaultTreeTransferGateVertex {
  constructor(key: string, value: GateVertexValue) {
    super(key, value);
  }

  getType(): string {
    return 'Instance Fault Tree Transfer Gate';
  }

  getMyStyle(): { [index: string]: any } {
    const style: {[index: string]: any} = super.getMyStyle();
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(238,152,56,0.20)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(238,152,56,0.75)';
    return style;
  }

  clone(): FaultTreeInstanceTransferGateVertex {
    return new FaultTreeInstanceTransferGateVertex(null, this.value.clone());
  }
}

export default FaultTreeInstanceTransferGateVertex;
